import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import IconTooltip from '../dump/menuComponents/IconTooltip'
import ModalDelete from '../smart/modals/ModalDelete'

import './EventVideoExpiration.sass'

const EventVideoExpiration = (props) => {
	const { t } = useTranslation('translation', { keyPrefix: 'accountPage.accountFleetSettings' });
	const { value, className, onChange, companyId } = props;
	const isProd = window.location.hostname === 'fleet.roscolive.com';
	const allowedCompanyIds = isProd ? [2281, 3282] : [825];
	const allow36Months = allowedCompanyIds.includes(Number(companyId));

	const [eventExpiration, setEventExpiration] = useState(null)
	const [showModalConfirmation, setShowModalConfirmation] = useState(false)

	return (
		<div className={`event-video-expiration ${className || ''}`}>
			<IconTooltip
				description={t('descriptionVideoExpire')}
			/>
			<label htmlFor="active" className="control-label">{t('labelExpiration')}</label>
			<select
				placeholder="select"
				className="rosco-select"
				name="event_expiration"
				value={value}
				onChange={(e) => {setEventExpiration(e.target.value);setShowModalConfirmation(true);}}
			>
				<option value="14">2 {t('textWeeks')}</option>
				<option value="30">1 {t('textMonth')}</option>
				<option value="90">3 {t('textMonths')}</option>
				<option value="180">6 {t('textMonths')}</option>
				<option value="365">12 {t('textMonths')}</option>
				{allow36Months && <option value="1095">36 {t('textMonths')}</option>}
			</select>

			{showModalConfirmation &&
				<ModalDelete
					title="Making changes to Event Video Expiration ?"
					content="Changing this setting will permanently delete all event videos stored outside of the selected time range. This action cannot be undone. Please confirm that you want to proceed."
					showClose
					deleteBtnName="Confirm"
					styleView="primary"
					closeModal={() => { setShowModalConfirmation(false) }}
					deleteModal={() => {onChange(eventExpiration);setShowModalConfirmation(false); }}
				/>
			}
		</div>					
	)
}

export default EventVideoExpiration
